// constants/index.ts
export const UPLOAD_CONSTANTS = {
    MAX_IMAGES: 10,
    ALLOWED_EXTENSIONS: ['.jpg', '.jpeg'],
    MAX_PROCESSING_ATTEMPTS: 10,
    PROCESSING_RETRY_DELAY: 2000,
  };